import { render, staticRenderFns } from "./EditUserProfileModal.vue?vue&type=template&id=44bc1fb5&scoped=true"
import script from "./EditUserProfileModal.vue?vue&type=script&lang=js"
export * from "./EditUserProfileModal.vue?vue&type=script&lang=js"
import style0 from "./EditUserProfileModal.vue?vue&type=style&index=0&id=44bc1fb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc1fb5",
  null
  
)

export default component.exports